import React, { useState } from "react";

export default function PortfolioOverview()
{
    const [selectedFilter, setSelectedFilter] =
        useState("ALL");
		

		const filters =
		[
		    {
		        code: "ALL",
		        label: "All Insights",
		        count: 82,
		        colour1: "#64748b",
		        colour2: "#475569"
		    },
		    {
		        code: "SAFETY",
		        label: "Safety",
		        count: 24,
		        colour1: "#ef4444",
		        colour2: "#dc2626"
		    },
		    {
		        code: "COMPLIANCE",
		        label: "Compliance",
		        count: 19,
		        colour1: "#f97316",
		        colour2: "#ea580c"
		    },
		    {
		        code: "ASSETS",
		        label: "Assets",
		        count: 17,
		        colour1: "#3b82f6",
		        colour2: "#2563eb"
		    },
		    {
		        code: "MAINTENANCE",
		        label: "Maintenance",
		        count: 13,
		        colour1: "#22c55e",
		        colour2: "#16a34a"
		    },
		    {
		        code: "ENERGY",
		        label: "Energy",
		        count: 9,
		        colour1: "#8b5cf6",
		        colour2: "#6d28d9"
		    }
		];

    const buildButton =
        (filter) =>
        {
            const active =
                selectedFilter === filter.code;

            return (

                <div
                    key={filter.code}

                    onClick={() =>
                        setSelectedFilter(
                            filter.code)}

                    style={{
                        flex: 1,

                        minWidth: "165px",

                        height: "72px",

                        borderRadius: "0px",

                        cursor: "pointer",

                        userSelect: "none",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "space-between",

                        padding:
                            "0 20px",

                        background:
                            `linear-gradient(
                                180deg,
                                ${filter.colour1} 0%,
                                ${filter.colour2} 100%)`,

                        color: "white",

                        boxShadow:
                            active
                                ? "0 0 0 3px #bfdbfe, 0 12px 28px rgba(0,0,0,.22)"
                                : "0 8px 18px rgba(0,0,0,.18)",

                        transform:
                            active
                                ? "translateY(-2px)"
                                : "translateY(0px)",

                        transition:
                            ".2s ease"
                    }}

                    onMouseEnter={(e)=>
                    {
                        if (!active)
                        {
                            e.currentTarget.style.transform =
                                "translateY(-2px)";

                            e.currentTarget.style.boxShadow =
                                "0 12px 28px rgba(0,0,0,.22)";
                        }
                    }}

                    onMouseLeave={(e)=>
                    {
                        if (!active)
                        {
                            e.currentTarget.style.transform =
                                "translateY(0px)";

                            e.currentTarget.style.boxShadow =
                                "0 8px 18px rgba(0,0,0,.18)";
                        }
                    }}
                >

                    <div>

                        <div
                            style={{
                                fontSize: "13px",
                                fontWeight: 600,
                                textTransform:
                                    "uppercase",
                                letterSpacing:
                                    "1px",
                                opacity: .9
                            }}
                        >
                            {filter.label}
                        </div>

                        <div
                            style={{
                                marginTop: "4px",

                                fontSize: "15px",

                                opacity: .85
                            }}
                        >
                            Insights
                        </div>

                    </div>

                    <div
                        style={{
                            fontSize: "34px",
                            fontWeight: 700,
                            lineHeight: 1
                        }}
                    >
                        {filter.count}
                    </div>

                </div>

            );
        };

    return (

        <div
            style={{
                display: "flex",

                gap: "16px",

                width: "calc(100% - 80px)",
				marginLeft:'40px',
				marginRight:'40px',

                flexWrap: "wrap"
            }}
        >

            {filters.map(buildButton)}

        </div>

    );
}